// Modules
import React from "react";

// Styles
import "./ResortDropdown.sass";

// Interfaces
import Resort from "Interfaces/ResortInterface";

// Components
import MvCheckBox from "Generic/MvCheckBox";

// Add to props interface/type
interface ResortDropdownGroupProps {
  selected : string[];
  limit: number;
  group: Resort[];
  name: string;
  onSelection(name:string[]):void;
  onRemoval(name:string[]):void;
  keydown(key:string, event: React.KeyboardEvent<HTMLElement>):void;
  setItemRef(ref: any, itemRef: string):void;
  resortsQueryParam?: string;
}

class ResortDropdownGroup extends React.Component<ResortDropdownGroupProps, {}> {

  constructor(props: ResortDropdownGroupProps) {
    super(props);
  }

  componentDidMount() {
    // On initial load, if resortsQueryParam exists, trigger selectItem for each resortId in the param (comma-separated)
    if (this.props.resortsQueryParam) {
      const resortIds = this.props.resortsQueryParam.split(',').map(id => id.trim()).filter(Boolean);
      // Instead of calling selectItem (which only updates local state), call onSelection to update parent state
      if (resortIds.length > 0) {
        this.props.onSelection(resortIds);
      }
    }
  }

  selectGroup(resortList:string[]) {
    let selectionGroup = this.props.group.map((resort) => resort.resortId);
    let allSelected = selectionGroup.every((resortName: string) => {
      return this.props.selected.indexOf(resortName) > -1;
    });

    if (!allSelected) {
      //need to select a subset up to limit and skip any already selected
      let selected = this.props.selected.length;
      let resortSubList = [] as string[];
      this.props.group.map(resort => {
        if (selected < this.props.limit && this.props.selected.indexOf(resort.resortId) === -1) {
          selected = selected + 1;
          return resortSubList.push(resort.resortId);
        }
      });
      this.props.onSelection(resortSubList);
    } else {
      this.props.onRemoval(resortList);
    }
  }

  selectItem(resort:string) {
    let theItemIndex = this.props.selected.indexOf(resort);
    if (theItemIndex > -1) {
      this.props.onRemoval([resort]);
    } else {
      this.props.onSelection([resort]);
    }
  }

  singleKeyDown(resortId:string, itemRef:string, event: React.KeyboardEvent<HTMLElement> ){
    if (event.keyCode === 32) {
      event.preventDefault();
      this.selectItem(resortId);
    } else {
      this.props.keydown(itemRef, event);
    }
  }

  groupKeyDown(event: React.KeyboardEvent<HTMLElement>, resortList:string[]) {
    const stateName = this.props.group[0].city;

    if (event.keyCode === 32) {
      this.selectGroup(resortList);
    } else {
      this.props.keydown(stateName, event);
    }
  }

  render() {
    const stateName = this.props.name;

    let selectionGroup = this.props.group.map((resort: { resortId: any; }) => resort.resortId);
    let allSelected = selectionGroup.every((resortName: string) => {
      return this.props.selected.indexOf(resortName) > -1;
    })

    const isStateListed:boolean = (stateName !== '' && stateName.length > 0 && stateName !== 'NO-STATE');

    console.log("resortsQueryParam in ResortDropdownGroup:", this.props.resortsQueryParam);

    // if (this.props.resortsQueryParam) {
    //   const resortIds = this.props.resortsQueryParam.split(',').map(id => id.trim()).filter(Boolean);
    //   resortIds.forEach(resortId => {
    //     this.selectItem(resortId);
    //   });
    // }

    return (
      <React.Fragment>
        <div id="region" className="group-title">
          {isStateListed ?
              <div
                className="state-wrapper"
                tabIndex={3}
                role="checkbox"
                aria-checked={allSelected}
                onKeyDown={(e) => this.groupKeyDown(e, selectionGroup)}
                aria-label={stateName}
                onClick={() => {
                  this.selectGroup(selectionGroup);
                }}
                ref={(ref: any) => this.props.setItemRef(ref, stateName)}
              >
                <MvCheckBox
                  checked={allSelected}
                  onChange={() => {
                    this.selectGroup(selectionGroup);
                  }}
                  label={stateName}
                  class="state-title"
                  tabIndex={-1}
                />
              </div> : ""
          }

          <ul className="hotel" role="listbox">
            {this.props.group.map(item => {
              let selected;
              if(this.props.selected.indexOf(item.resortId) > -1) {
                selected = true
              } else {
                selected = false
              }

            const singleResortRef = `${stateName}-${item.resortId}`;

            return (
              <li key={item.resortId}
                  aria-label={item.name + ", " + item.city + " " }
                  className="single-hotel"
                  role="checkbox"
                  aria-checked={selected}
                  aria-selected={this.props.selected.indexOf(item.resortId) > -1}
                  tabIndex = {!isStateListed ? 3 : -1}
                  onKeyDown={(event)=>this.singleKeyDown(item.resortId, singleResortRef, event)}
                  onClick={() => {
                    this.selectItem(item.resortId);
                  }}
                  ref={(ref:any) => this.props.setItemRef(ref, singleResortRef)}
                >
                <MvCheckBox
                  checked={this.props.selected.indexOf(item.resortId) > -1}
                  onChange={() => {
                    this.selectItem(item.resortId);
                  }}
                  label={item.name + ", " + item.city}
                  tabIndex={-1}
                />
              </li>
            );
          })}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}
export default ResortDropdownGroup;
